import request from "../helpers/request";
import {createRestfulApi} from "./createRestfulApi";
import download from "@/helpers/download";

const URL = {
    // 教学数据
    GETDATALESSONINFO: "olap/getDataLessonInfo",
    GETDATATESTINFO: "olap/getDataTestInfo",
    GETDATAMARKINFO: "olap/getDataMarkInfo",
    // 学院数据
    GETDATAUSERINFO: "olap/getDataUserInfo",
    //全量导出学员数据
    EXPORTDATAUSERINFO: "olap/exportDataUserInfo",
    GET_ANALYSE_DATA: "olap/getAnalyseData",
    EXPORT_TRAINEE_DATA: "olap/exportTraineeData",
};

export default {
    getAnalyseData(payload) {
        return request(URL.GET_ANALYSE_DATA, "POST", payload);
    },
    async exportTraineeData(payload) {
        const file = await request(URL.EXPORT_TRAINEE_DATA, "POST", payload, true);
        download(file, `学员数据.xls`);
    },
    getTeachingDataList: createRestfulApi(URL.GETDATALESSONINFO, {
        queryParams: [],
    }),
    getDataTestInfo({id}) {
        return request(URL.GETDATATESTINFO, "POST", {id});
    },
    getDataMarkInfo({id}) {
        return request(URL.GETDATAMARKINFO, "POST", {id});
    },
    getDataUserInfo: createRestfulApi(URL.GETDATAUSERINFO, {
        queryParams: [],
    }),
    async exportDataUserInfo() {
        const file = await request(URL.EXPORTDATAUSERINFO, "POST", {}, true);
        download(file, `学员数据.xls`);
    },
};
